import { useState, useContext, useEffect, useCallback } from 'react'
import Input from '../ui/input/input'
import Button from '../ui/button/button'
import { AuthContext } from '../../context/auth.context'
import { AxiosContext } from '../../context/request.context'
import useUsers from '../../hooks/users.hook'

const qs = require('qs')

function Authorization({message, loading, onSubmitHandler, setCredentials }) {

  const onTokenHandler = ({ target: { value } }) => {
    setCredentials(credentials => ({
      ...credentials,
      token: value
    }))
  }

  const onOrderIdHandler = ({ target: { value } }) => {
    setCredentials(credentials => ({
      ...credentials,
      orderId: value
    }))
  }



  const onEnter = useCallback(
    event => {
      if (event.key === 'Enter') {
        onSubmitHandler()
      }
    },
    [onSubmitHandler]
  )

  useEffect(() => {
    window.addEventListener('keyup', onEnter)
    return () => {
      window.removeEventListener('keyup', onEnter)
    }
  }, [onEnter])

  return (
    <div className='p-[7rem]'>
      <span className='block text-center text-Regular(48_52) text-Content/Dark mb-[5rem]'>
        Получить данные о заказе
      </span>
      <div className='p-[5rem] bg-Dominant/Dop w-[62.6rem] '>
        <div className='flex flex-col gap-[2.6rem]'>
          <Input
            // icon='icon-user'
            onInput={onTokenHandler}
            label='ID компании'
            placeholder='Введите ID вашей компании'></Input>
          <Input
            // icon='icon-lock'
            onInput={onOrderIdHandler}
            label='Номер заказа'
            placeholder='Введите номер заказа'></Input>
        </div>
        {message && (
          <span className='bg-Accent/Rose p-[1rem] text-Regular(12_14) text-Content/Dark mt-[1.2rem] block text-left'>
            {message}
          </span>
        )}

        <div className='mt-[5rem] max-w-[23rem] m-auto flex justify-center'>
          <Button loading={loading} onPress={onSubmitHandler} name='Далее'></Button>
        </div>
      </div>
    </div>
  )
}

export default Authorization
